import './index_mWeb.css';
import React, { useState } from 'react';
import { View, HeaderWithTimer, RouteWrapper } from '../../../component';
import { ContestShare, ContestDetailsWinningBreakup } from '../../component';
import ContestLeaderboardMWeb from '../../component/contest_leaderboard/index_mWeb';
import SwipeableViews from 'react-swipeable-views';
import ContestDetailsTabBar from '../../component/contest_details_tab_bar';
import { useLink } from 'react-router-stack';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
import { useSelector } from 'react-redux';
const ContestDetailsMWeb = ({
  onPressShare,
  contestDetail,
  matchStatus,
  gameState,
  matchItem,
  totalTeamsCount,
  matchDelayed,
  gameType,
  getContestUserLeaderboard,
  getContestLeaderboard,
  fantasyMatchClick,
  completed,
  contestId,
  userId,
  winningsPerPosition,
  entryFee,
  tabType,
  matchVerifiedStatus,
  bonusPercentage,
  matchId,
  getPlayerList,
  matchTeamLock,
  myTeamList,
  isGadgetLeague_,
  description,
  winningData,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss
}: any) => {
  const navigate = useLink();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const [routes] = useState([
    { key: 'Winnings', title: 'Winnings Breakup' },
    { key: 'LeaderBoard', title: 'LeaderBoard' }
  ]);

  const [activeTab, setActiveTab] = useState(0);

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  const onChangeTabIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          tabType={tabType}
          onCalledDeadline={onCalledDeadline}
          isCreateTeam={false}
          teamName={teamName}
        />

        <ContestCardMWeb
          isContestDetails={true}
          contest={contestDetail}
          onPressCard={() => {}}
          onPressShare={() => onPressShare()}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          totalTeamsCount={totalTeamsCount}
          screenName={'CONTEST_DETAILS'}
          matchDelayed={matchDelayed}
          gameType={gameType}
        />
        <View className={'contest-details-tab-view-wrapper_mWeb'}>
          <View
            style={{
              flexGrow: 1,
              height: '100%'
            }}>
            <ContestDetailsTabBar onChangeTab={onChangeTab} activeTab={activeTab} routes={routes} />
            <div className="flat-list-outer-grow">
              <SwipeableViews
                index={activeTab}
                onChangeIndex={onChangeTabIndex}
                className={'contest-details-swipeable-view_mWeb'}>
                <ContestDetailsWinningBreakup
                  winningData={winningData}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                />
                <ContestLeaderboardMWeb
                  gameType={gameType}
                  getContestUserLeaderboard={getContestUserLeaderboard}
                  getContestLeaderboard={getContestLeaderboard}
                  fantasyMatchClick={fantasyMatchClick}
                  completed={completed}
                  matchStatus={matchStatus}
                  matchItem={matchItem}
                  contestId={contestId}
                  userId={userId}
                  winningsPerPosition={winningsPerPosition}
                  entryFee={entryFee}
                  tabType={tabType}
                  matchVerifiedStatus={matchVerifiedStatus}
                  bonusPercentage={bonusPercentage}
                  gameState={gameState}
                  matchId={matchId}
                  getPlayerList={getPlayerList}
                  matchTeamLock={matchTeamLock}
                  myTeamListLen={myTeamList.length}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                />
              </SwipeableViews>
            </div>
          </View>
        </View>
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default ContestDetailsMWeb;
